import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']

  clear() {
    this.inputTargets.forEach(input => {
      if (input.type === 'checkbox' || input.type === 'radio') {
        input.checked = false
      } else {
        input.value = ''
      }
    })
  }
}
